import { FunctionComponent } from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';

import { BUTTON_TYPES } from '@savgroup-front-common/constants';

import { Loader } from '../../../../../loader';
import { $OptionDescription } from '../../../Autocomplete.styles';
import {
  $PlaceAutcompleteButton,
  $PlaceAutcompleteItem,
} from '../../PlacesAutocomplete.styles';
import { Place } from '../../PlacesAutocomplete.types';

interface PlaceAutocompleteResultProps {
  place: Place;
  onSelect: (place: Place) => void;
  isSelected: boolean;
  isLoading: boolean;
  dataTestId?: string;
}

const PlaceAutocompleteResult: FunctionComponent<
  PlaceAutocompleteResultProps
> = ({ place, onSelect, isSelected, isLoading, dataTestId }) => {
  return (
    <$PlaceAutcompleteItem>
      <$PlaceAutcompleteButton
        title={place.description}
        type={BUTTON_TYPES.BUTTON}
        onClick={() => onSelect(place)}
        $isSelected={isSelected}
        tabIndex={-1}
        data-testid={dataTestId}
      >
        <Row middle="xs">
          <Col>
            <div>{place.mainText}</div>
            {place.secondaryText && (
              <$OptionDescription>{place.secondaryText}</$OptionDescription>
            )}
          </Col>
          {isLoading && (
            <Col>
              <Loader />
            </Col>
          )}
        </Row>
      </$PlaceAutcompleteButton>
    </$PlaceAutcompleteItem>
  );
};

export default PlaceAutocompleteResult;
